import ProjectComparisonContainer from './ProjectComparison';
export default ProjectComparisonContainer;
